<template>
  <div class="member-info-content">
    <!-- 基本資料 -->
    <div class="info-section">
      <div class="section-header">
        <h4 class="section-title">基本資料</h4>
        <el-button type="text" size="mini" class="edit-btn" @click="openBasicDialog">
          <i class="el-icon-edit" />
          編輯資訊
        </el-button>
      </div>
      <div class="info-row">
        <span class="label">姓名：</span>
        <span class="value">{{ info.fullName || '-' }} {{ genderSuffix }}</span>
      </div>
      <div class="info-row">
        <span class="label">聯絡電話：</span>
        <span class="value">{{ info.phoneCode }} {{ info.phoneNumber || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="label">身份證字號：</span>
        <span class="value">{{ maskedNationalId || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="label">LINE ID：</span>
        <span class="value">{{ info.lineId || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="label">電子信箱：</span>
        <span class="value">{{ info.email || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="label">標籤：</span>
        <span class="value">
          <el-tag v-for="tag in info.tags" :key="tag.id" type="info" color="#E5E7EB" size="small" style="color: #121931; border-radius: 8px; margin-right: 4px;">
            {{ tag.title }}
          </el-tag>
          <span v-if="!info.tags || info.tags.length === 0">-</span>
        </span>
      </div>
    </div>

    <el-divider></el-divider>

    <!-- 地址 -->
    <div class="info-section">
      <div class="section-header">
        <h4 class="section-title">地址</h4>
        <el-button type="text" size="mini" class="edit-btn" @click="openAddressDialog">
          <i class="el-icon-edit" />
          編輯資訊
        </el-button>
      </div>
      <div class="info-row">
        <span class="label">帳單地址：</span>
        <span class="value">{{ billingAddressDisplay || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="label">收件地址：</span>
        <span class="value">{{ shippingAddressDisplay || '-' }}</span>
      </div>
    </div>

    <el-divider></el-divider>

    <!-- 發票資訊 -->
    <div class="info-section">
      <div class="section-header">
        <h4 class="section-title">發票資訊</h4>
        <el-button type="text" size="mini" class="edit-btn" @click="openInvoiceDialog">
          <i class="el-icon-edit" />
          編輯資訊
        </el-button>
      </div>
      <div class="info-row">
        <span class="label">開立類型：</span>
        <span class="value">{{ taxTypeDisplay || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="label">載具類別：</span>
        <span class="value">{{ carrierTypeDisplay || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="label">載具編號：</span>
        <span class="value">{{ info.CarrierNum || '-' }}</span>
      </div>
    </div>

    <!-- 基本資料編輯對話框 -->
    <el-dialog title="編輯基本資料" :visible.sync="basicDialogVisible" width="500px" top="1vh" append-to-body @close="resetBasicForm">
      <el-form ref="basicForm" :model="basicForm" :rules="basicRules" label-position="top" class="edit-form">
        <el-form-item label="姓名" prop="fullName">
          <el-input v-model="basicForm.fullName" placeholder="請輸入姓名" />
        </el-form-item>
        <el-form-item label="稱呼">
          <el-radio-group v-model="basicForm.salutation">
            <el-radio label="male">先生</el-radio>
            <el-radio label="female">小姐</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="國碼" prop="phoneCode">
              <el-select v-model="basicForm.phoneCode" placeholder="國碼">
                <el-option label="+886" value="+886" />
                <el-option label="+86" value="+86" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="聯絡電話" prop="phoneNumber">
              <el-input v-model="basicForm.phoneNumber" placeholder="請輸入電話" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="身份證字號" prop="nationalId">
          <el-input v-model="basicForm.nationalId" placeholder="請輸入身份證字號" />
        </el-form-item>
        <el-form-item label="LINE ID" prop="lineId">
          <el-input v-model="basicForm.lineId" placeholder="請輸入 LINE ID" />
        </el-form-item>
        <el-form-item label="電子信箱" prop="email">
          <el-input v-model="basicForm.email" placeholder="請輸入 Email" />
        </el-form-item>
        <el-form-item label="標籤">
          <el-select v-model="basicForm.tags" multiple filterable placeholder="請選擇標籤" value-key="id">
            <el-option v-for="tag in tagList" :key="tag.id" :label="tag.title" :value="tag" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="basicDialogVisible = false">取消</el-button>
        <el-button type="primary" round :loading="savingBasic" @click="saveBasicInfo">儲存</el-button>
      </div>
    </el-dialog>

    <!-- 地址編輯對話框 -->
    <el-dialog title="編輯地址" :visible.sync="addressDialogVisible" width="500px" top="1vh" append-to-body @close="resetAddressForm">
      <el-form ref="addressForm" :model="addressForm" label-position="top" class="edit-form">
        <h5 class="form-subtitle">帳單地址</h5>
        <el-form-item label="姓名">
          <el-input v-model="addressForm.billingName" placeholder="請輸入姓名" />
        </el-form-item>
        <el-form-item label="電話">
          <el-input v-model="addressForm.billingPhone" placeholder="請輸入電話" />
        </el-form-item>
        <el-form-item label="電子郵件">
          <el-input v-model="addressForm.billingEmail" placeholder="請輸入電子郵件" />
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="縣市">
              <el-select v-model="addressForm.billingCity" placeholder="請選擇縣市" filterable @change="onBillingCityChange">
                <el-option v-for="city in taiwanCitys" :key="city.name" :label="city.name" :value="city.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="鄉鎮市區">
              <el-select v-model="addressForm.billingDistrict" placeholder="請選擇鄉鎮市區" filterable @change="onBillingDistrictChange">
                <el-option v-for="district in billingDistricts" :key="district.name" :label="district.name" :value="district.name" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="郵政編號">
          <el-input v-model="addressForm.billingPostcode" placeholder="請輸入郵政編號" />
        </el-form-item>
        <el-form-item label="詳細地址">
          <el-input v-model="addressForm.billingAddress" placeholder="請輸入詳細地址" />
        </el-form-item>

        <el-divider></el-divider>

        <h5 class="form-subtitle">收件地址</h5>
        <el-form-item label="姓名">
          <el-input v-model="addressForm.shippingName" placeholder="請輸入姓名" />
        </el-form-item>
        <el-form-item label="電話">
          <el-input v-model="addressForm.shippingPhone" placeholder="請輸入電話" />
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="縣市">
              <el-select v-model="addressForm.shippingCity" placeholder="請選擇縣市" filterable @change="onShippingCityChange">
                <el-option v-for="city in taiwanCitys" :key="city.name" :label="city.name" :value="city.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="鄉鎮市區">
              <el-select v-model="addressForm.shippingDistrict" placeholder="請選擇鄉鎮市區" filterable @change="onShippingDistrictChange">
                <el-option v-for="district in shippingDistricts" :key="district.name" :label="district.name" :value="district.name" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="郵政編號">
          <el-input v-model="addressForm.shippingPostcode" placeholder="請輸入郵政編號" />
        </el-form-item>
        <el-form-item label="詳細地址">
          <el-input v-model="addressForm.shippingAddress" placeholder="請輸入詳細地址" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="addressDialogVisible = false">取消</el-button>
        <el-button type="primary" round :loading="savingAddress" @click="saveAddressInfo">儲存</el-button>
      </div>
    </el-dialog>

    <!-- 發票編輯對話框 -->
    <el-dialog title="編輯發票資訊" :visible.sync="invoiceDialogVisible" width="500px" top="1vh" append-to-body @close="resetInvoiceForm">
      <el-form ref="invoiceForm" :model="invoiceForm" :rules="invoiceRules" label-position="top" class="edit-form">
        <el-form-item label="開立類型" prop="taxType">
          <el-radio-group v-model="invoiceForm.taxType">
            <el-radio label="B2C">個人</el-radio>
            <el-radio label="B2B">公司</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="invoiceForm.taxType === 'B2B'">
          <el-form-item label="統一編號" prop="taxId">
            <el-input v-model="invoiceForm.taxId" placeholder="請輸入統一編號" />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="載具類別" prop="CarrierType">
            <el-select v-model="invoiceForm.CarrierType" placeholder="請選擇載具類別">
              <el-option label="無（寄送電子發票至客戶 email）" value="" />
              <el-option label="手機條碼" value="0" />
              <el-option label="自然人憑證" value="1" />
              <el-option label="ezPay 電子發票載具" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="invoiceForm.CarrierType === '0' || invoiceForm.CarrierType === '1'" label="載具編號" prop="CarrierNum">
            <el-input v-model="invoiceForm.CarrierNum" placeholder="請輸入載具編號" />
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="invoiceDialogVisible = false">取消</el-button>
        <el-button type="primary" round :loading="savingInvoice" @click="saveInvoiceInfo">儲存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { taiwanCitys, districtsFilter, findDistrictZip } from '@utils/filter-value-to-text'

const taxTypeMap = {
  B2C: '個人',
  B2B: '公司',
}

const carrierTypeMap = {
  '': '無（寄送電子發票至客戶 email）',
  '0': '手機條碼',
  '1': '自然人憑證',
  '2': '會員載具',
}

export default {
  name: 'MemberInfoContent',
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      taiwanCitys,
      tagList: [],
      // 基本資料
      basicDialogVisible: false,
      savingBasic: false,
      basicForm: {
        fullName: '',
        salutation: 'male',
        phoneCode: '+886',
        phoneNumber: '',
        nationalId: '',
        lineId: '',
        email: '',
        tags: [],
      },
      basicRules: {
        fullName: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        phoneNumber: [{ required: true, message: '請輸入聯絡電話', trigger: 'blur' }],
      },
      // 地址
      addressDialogVisible: false,
      savingAddress: false,
      addressForm: {
        billingName: '',
        billingPhone: '',
        billingEmail: '',
        billingCity: '',
        billingDistrict: '',
        billingAddress: '',
        billingPostcode: '',
        shippingName: '',
        shippingPhone: '',
        shippingCity: '',
        shippingDistrict: '',
        shippingAddress: '',
        shippingPostcode: '',
      },
      // 發票
      invoiceDialogVisible: false,
      savingInvoice: false,
      invoiceForm: {
        taxType: 'B2C',
        taxId: '',
        CarrierType: '',
        CarrierNum: '',
      },
      invoiceRules: {
        taxId: [{ required: true, message: '請輸入統一編號', trigger: 'blur' }],
        CarrierNum: [{ required: true, message: '請輸入載具編號', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.tryToFetchTagList()
  },
  computed: {
    genderSuffix() {
      const gender = this.info && this.info.gender
      if (gender === 'male') return '先生'
      if (gender === 'female') return '小姐'
      return ''
    },
    maskedNationalId() {
      const extraInfos = this.info && this.info.extraInfos
      const nationalId = extraInfos && extraInfos.nationalId
      if (nationalId) {
        const firstChar = nationalId.charAt(0).toUpperCase()
        const maskedMiddle = '******'
        const lastThree = nationalId.slice(-3)
        return firstChar + maskedMiddle + lastThree
      }
      return ''
    },
    billingAddressDisplay() {
      const billingInfo = this.info && this.info.billingInfo
      if (billingInfo && Object.keys(billingInfo).length) {
        return `${billingInfo.city || ''}${billingInfo.district || ''}${billingInfo.address || ''}`
      }
      return ''
    },
    shippingAddressDisplay() {
      const shippingInfo = this.info && this.info.shippingInfo
      if (shippingInfo && shippingInfo.length && shippingInfo[0]) {
        const addr = shippingInfo[0]
        return `${addr.city || ''}${addr.district || ''}${addr.address || ''}`
      }
      return ''
    },
    taxTypeDisplay() {
      return taxTypeMap[this.info && this.info.taxType] || ''
    },
    carrierTypeDisplay() {
      const carrierType = this.info && this.info.CarrierType
      return carrierTypeMap[carrierType] || ''
    },
    billingDistricts() {
      return districtsFilter(this.addressForm.billingCity)
    },
    shippingDistricts() {
      return districtsFilter(this.addressForm.shippingCity)
    },
  },
  methods: {
    async tryToFetchTagList(search) {
      try {
        this.tagList = await this.$store.dispatch('member/fetchTags', {
          search,
        })
      } catch (e) {
        this.tagList = []
      }
    },
    // 基本資料
    openBasicDialog() {
      this.basicForm = {
        fullName: this.info.fullName || '',
        salutation: this.info.gender || 'male',
        phoneCode: this.info.phoneCode || '+886',
        phoneNumber: this.info.phoneNumber || '',
        nationalId: (this.info.extraInfos && this.info.extraInfos.nationalId) || '',
        lineId: this.info.lineId || '',
        email: this.info.email || '',
        tags: (this.info.tags && this.info.tags.slice()) || [],
      }
      this.basicDialogVisible = true
    },
    resetBasicForm() {
      this.basicForm = {
        fullName: '',
        salutation: 'male',
        phoneCode: '+886',
        phoneNumber: '',
        nationalId: '',
        lineId: '',
        email: '',
        tags: [],
      }
    },
    async saveBasicInfo() {
      try {
        await this.$refs.basicForm.validate()
      } catch (e) {
        return
      }
      this.savingBasic = true
      try {
        const tagIds = (this.basicForm.tags || []).map((t) => t.id)
        const { tags, ...baseInfo } = this.info || {}
        const payload = {
          ...baseInfo,
          fullName: this.basicForm.fullName,
          gender: this.basicForm.salutation,
          phoneCode: this.basicForm.phoneCode,
          phoneNumber: this.basicForm.phoneNumber,
          phone: this.basicForm.phoneNumber,
          lineId: this.basicForm.lineId,
          email: this.basicForm.email,
          extraInfos: {
            ...(this.info.extraInfos || {}),
            nationalId: this.basicForm.nationalId,
          },
          tagIds,
        }
        await this.$store.dispatch('member/store', payload)
        // 本地更新 info 中的 tags，以防後續地址或發票編輯時使用
        this.$set(this.info, 'tags', this.basicForm.tags)
        this.$message.success('儲存成功')
        this.basicDialogVisible = false
        this.$emit('update', this.info.id)
      } catch (error) {
        this.$message.error('儲存失敗')
      } finally {
        this.savingBasic = false
      }
    },
    // 地址
    openAddressDialog() {
      const billingInfo = this.info.billingInfo || {}
      const shippingInfo = (this.info.shippingInfo && this.info.shippingInfo[0]) || {}
      this.addressForm = {
        billingName: billingInfo.name || this.info.fullName || '',
        billingPhone: billingInfo.phone || this.info.phoneNumber || '',
        billingEmail: billingInfo.email || this.info.email || '',
        billingCity: billingInfo.city || '',
        billingDistrict: billingInfo.district || '',
        billingAddress: billingInfo.address || '',
        billingPostcode: billingInfo.postcode || '',
        shippingName: shippingInfo.name || this.info.fullName || '',
        shippingPhone: shippingInfo.phone || this.info.phoneNumber || '',
        shippingCity: shippingInfo.city || '',
        shippingDistrict: shippingInfo.district || '',
        shippingAddress: shippingInfo.address || '',
        shippingPostcode: shippingInfo.postcode || '',
      }
      this.addressDialogVisible = true
    },
    resetAddressForm() {
      this.addressForm = {
        billingName: '',
        billingPhone: '',
        billingEmail: '',
        billingCity: '',
        billingDistrict: '',
        billingAddress: '',
        billingPostcode: '',
        shippingName: '',
        shippingPhone: '',
        shippingCity: '',
        shippingDistrict: '',
        shippingAddress: '',
        shippingPostcode: '',
      }
    },
    onBillingCityChange() {
      this.addressForm.billingDistrict = ''
      this.addressForm.billingPostcode = ''
    },
    onBillingDistrictChange() {
      this.addressForm.billingPostcode = findDistrictZip(this.addressForm.billingCity, this.addressForm.billingDistrict)
    },
    onShippingCityChange() {
      this.addressForm.shippingDistrict = ''
      this.addressForm.shippingPostcode = ''
    },
    onShippingDistrictChange() {
      this.addressForm.shippingPostcode = findDistrictZip(this.addressForm.shippingCity, this.addressForm.shippingDistrict)
    },
    async saveAddressInfo() {
      this.savingAddress = true
      try {
        const { tags, ...baseInfo } = this.info || {}
        const payload = {
          ...baseInfo,
          phone: this.info.phoneNumber,
          billingInfo: {
            ...(this.info.billingInfo || {}),
            name: this.addressForm.billingName,
            phone: this.addressForm.billingPhone,
            email: this.addressForm.billingEmail,
            city: this.addressForm.billingCity,
            district: this.addressForm.billingDistrict,
            address: this.addressForm.billingAddress,
            postcode: this.addressForm.billingPostcode,
          },
          shippingInfo: [
            {
              ...((this.info.shippingInfo && this.info.shippingInfo[0]) || {}),
              name: this.addressForm.shippingName,
              phone: this.addressForm.shippingPhone,
              city: this.addressForm.shippingCity,
              district: this.addressForm.shippingDistrict,
              address: this.addressForm.shippingAddress,
              postcode: this.addressForm.shippingPostcode,
            },
          ],
          tagIds: (this.info.tags || []).map((t) => t.id),
        }
        await this.$store.dispatch('member/store', payload)
        this.$message.success('儲存成功')
        this.addressDialogVisible = false
        this.$emit('update', this.info.id)
      } catch (error) {
        this.$message.error('儲存失敗')
      } finally {
        this.savingAddress = false
      }
    },
    // 發票
    openInvoiceDialog() {
      this.invoiceForm = {
        taxType: this.info.taxType || 'B2C',
        taxId: this.info.taxId || '',
        CarrierType: this.info.CarrierType || '',
        CarrierNum: this.info.CarrierNum || '',
      }
      this.invoiceDialogVisible = true
    },
    resetInvoiceForm() {
      this.invoiceForm = {
        taxType: 'B2C',
        taxId: '',
        CarrierType: '',
        CarrierNum: '',
      }
    },
    async saveInvoiceInfo() {
      try {
        await this.$refs.invoiceForm.validate()
      } catch (e) {
        return
      }
      this.savingInvoice = true
      try {
        const { tags, ...baseInfo } = this.info || {}
        const payload = {
          ...baseInfo,
          phone: this.info.phoneNumber,
          taxType: this.invoiceForm.taxType,
          taxId: this.invoiceForm.taxType === 'B2B' ? this.invoiceForm.taxId : '',
          CarrierType: this.invoiceForm.taxType === 'B2C' ? this.invoiceForm.CarrierType : '',
          CarrierNum: this.invoiceForm.taxType === 'B2C' && (this.invoiceForm.CarrierType === '0' || this.invoiceForm.CarrierType === '1') ? this.invoiceForm.CarrierNum : '',
          tagIds: (this.info.tags || []).map((t) => t.id),
        }
        await this.$store.dispatch('member/store', payload)
        this.$message.success('儲存成功')
        this.invoiceDialogVisible = false
        this.$emit('update', this.info.id)
      } catch (error) {
        this.$message.error('儲存失敗')
      } finally {
        this.savingInvoice = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.member-info-content {
  .info-section {
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #121931;
      padding-bottom: 8px;
      border-bottom: 2px solid #ea6a2a;
      display: inline-block;
      margin: 0;
    }

    .edit-btn {
      color: #ea6a2a;
      font-size: 14px;
      i {
        margin-right: 4px;
      }
    }
  }

  .info-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    line-height: 1.8;

    .label {
      color: #6c6b6b;
      min-width: 90px;
      flex-shrink: 0;
    }

    .value {
      color: #121931;
      flex: 1;

      &.highlight {
        color: #ea6a2a;
        font-weight: 600;
      }
    }
  }
}

.edit-form {
  .form-subtitle {
    font-size: 14px;
    font-weight: 600;
    color: #121931;
    margin-bottom: 16px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  gap: 12px;

  .el-button {
    flex: 1;
  }
}

::v-deep .el-dialog__body {
  padding-top: 10px;
}

::v-deep .el-form-item {
  margin-bottom: 18px;
}

::v-deep .el-form-item__label {
  font-weight: 500;
  padding-bottom: 4px;
}
</style>
